/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const updateUserCredit = params => {
  return axios.post(`${base}/add_crerdit_${params.userid}`, params)
}




// WEBPACK FOOTER //
// ./src/views/user-credit/user-credit.api.js